export const googleAnalyticsFields = [
  "fc_campaign",
  "fc_channel",
  "fc_content",
  "fc_landing",
  "fc_medium",
  "fc_referrer",
  "fc_source",
  "fc_term",
  "lc_campaign",
  "lc_channel",
  "lc_content",
  "lc_landing",
  "lc_medium",
  "lc_referrer",
  "lc_source",
  "lc_term",
  "OS",
  "GA_Client_ID",
  "all_traffic_sources",
  "browser",
  "city",
  "country",
  "device",
  "page_visits",
  "pages_visited_list",
  "time_zone",
  "time_passed",
  "latitude",
  "longitude",
  "gclid"
];

export const SERVER_ERROR_MESSAGE_FALLBACK = 'Something wrong happened';